import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';

import Accordion from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Accordion';
import AccordionSummary from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/AccordionSummary';
import AccordionDetails from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/AccordionDetails';
import Typography from 'Components/UI/Typography';

import Header from './Header';
import Body from './Body';

const styles = (theme) => ({
  root: {
    padding: theme.spacing(2),
    margin: theme.spacing(1, 0),
    borderRadius: theme.radius.md,
    '&:before': {
      display: 'none', // <--- Hides default boder bottom on open accordions
    },
  },
  header: {
    height: theme.spacing(5),
    padding: 0,
  },
  body: {},
  footer: {},
  accordion: {
    border: `1px solid ${theme.palette.grey[200]}`,
    borderRadius: theme.radius.md,
    '& .MuiAccordion-root:before': {
      display: 'none',
    },
  },
  roundedAccordion: {
    borderRadius: theme.radius.md,
  },
  summary: {
    width: '100%',
  },
  accountDetails: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: theme.spacing(1, 0, 0),
  },
  description: {
    whiteSpace: 'pre-wrap',
  },
});

const TYPE_MAP = {
  cash: {
    description: 'Click to identify where you have your cash\n(Checking, Savings, Money Market)',
  },
  investable: {
    description: 'Click to identify where you invest\n(Brokerage, 401k, IRAs, etc.)',
  },
  realAssets: {
    description: 'Click to identify what you own\n(Home, Cars, Jewelry, etc.)',
  },
  property: {
    description: 'Click to identify where you have your mortgage\n(Primary Residence, Rental Properties)',
  },
  creditCards: {
    description: 'Click to identify what credit cards you have',
  },
  otherLoans: {
    description: 'Any other loans you have\n(Auto, Student, Personal Line of Credit)',
  },
};

const BalanceSheetLineItemSection = ({
  className,
  classes,
  sectionResource,
}) => {
  const hasAccounts = sectionResource?.attr('accounts').resources().list().length >= 1;
  const sectionType = TYPE_MAP[sectionResource.id()];

  let description = 'Add accounts here.';
  if (sectionType) {
    // eslint-disable-next-line
    description = sectionType.description;
  }

  return (
    <Accordion
      className={classNames(classes.root, className)}
      classes={{
        root: classes.accordion,
        rounded: classes.roundedAccordion,
      }}
      defaultExpanded
      elevation={0}
      square
      test={`balance-sheet-${sectionResource.id()}-section`}
    >
      <AccordionSummary
        aria-controls={'balance-sheet-item-summary'}
        className={classes.header}
      >
        <Header
          sectionResource={sectionResource}
        />
      </AccordionSummary>
      <AccordionDetails
        className={classes.accountDetails}
      >
        <Body
          className={classes.body}
          sectionResource={sectionResource}
        />
        {!hasAccounts && (
          <Typography
            className={classes.description}
            color={'primaryGray'}
            align={'center'}
            test={'balance-sheet-section-description'}
          >
            {description}
          </Typography>)
        }
      </AccordionDetails>
    </Accordion>
  );
};

BalanceSheetLineItemSection.defaultProps = {
  className: '',
};

BalanceSheetLineItemSection.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  sectionResource: PropTypes.object.isRequired,
};

export default withStyles(styles)(BalanceSheetLineItemSection);
